<template>
  <main>
    <transition>
      <article v-if="page">
        <span v-ornament></span>
        <svg @click="suprematism()" viewBox="0 00 1600 1000" preserveAspectRatio="xMaxYMid  meet" id="suprematism">
        </svg>
        <span v-ornament></span>
        <div id="home">
          <p v-if="page.content" v-html="page.content.rendered"></p>
        </div>
      </article>
    </transition>
  </main>
</template>

<script>
import Axios from 'axios';
export default {
  data () {
    return {
      page: {}
    }
  },
  computed: {

  },
  mounted() {
    this.suprematism()
    var promise = new Promise((resolve,reject)=>{
      Axios.get('http://ecos.ec/wp-json/wp/v2/pages/'+2).then(res=>{
        this.page = res.data;
        resolve(true);
      });
    });
    this.loader(promise,"#home")
  },
  methods: {

  },
  filters: {
    shortDate(str) {
      return str.substring(0, 10).split('-').reverse().join('/');
    }
  }
}
</script>

<style scoped>
rect {
}
#ecos {
  z-index: 100000
}
#suprematism {
  cursor: pointer;
  margin: -1em 0;
}
main {
  padding: 2em 1em;
  max-width: 720px;
  margin: auto;
}
article {
  margin: auto;

}
article>div {
  display: flex;
  width: auto;
  flex-wrap: wrap;
  align-items: start
}
article>img {
  max-width: 100%;
}
h1 {
  font-weight: bold;
  font-size: 3.8em;
  text-align: center;
  margin: 0
}
small {
  color: #a1a1a1;
  margin: auto
}
nav {
  display: flex
}
@media (max-width: 700px) {
  #suprematism {
    margin: -1em -2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page.vue